<template>
    <div >
        <vx-card title="Approvers" subtitle="Lists of Approvers per Module"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewApprovers()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="getuserApprovers">
                    <template slot="thead">
                        
                        <vs-th>Approver</vs-th>
                        <vs-th>Module</vs-th>
                        <vs-th>Priority</vs-th>
                        <vs-th>Active?</vs-th>
                        <vs-th>From Date</vs-th>
                        <vs-th>To Date</vs-th>
                        <vs-th>No End Date</vs-th>
                        <vs-th>Auto Approved?</vs-th>
                        <vs-th>Auto Denied?</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"> 
                            <vs-td :data="data[indextr].approverId">
                                {{ getEmployeeByUserId(data[indextr].approverId).fullName }}
                            </vs-td>
                            <vs-td :data="data[indextr].module">
                                {{ moduleLookup(data[indextr].module).moduleName }}
                            </vs-td>
                            <vs-td :data="data[indextr].priority">
                                {{ priorityLookup(data[indextr].priority).priorityName }}
                            </vs-td>
                            <vs-td :data="data[indextr].isActive">
                                <vs-checkbox v-model="data[indextr].isActive" class="pointer-events-none" />
                            </vs-td>
                            <vs-td :data="data[indextr].fromDate">
                                {{data[indextr].fromDate | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].toDate">
                                {{data[indextr].toDate | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].isNoEndDate">
                                 <vs-checkbox v-model="data[indextr].isNoEndDate" class="pointer-events-none"  />
                            </vs-td>
                            <vs-td :data="data[indextr].isAutoApproved">
                                <vs-checkbox v-model="data[indextr].isAutoApproved" class="pointer-events-none" />
                            </vs-td>
                            <vs-td :data="data[indextr].isAutoDenied">
                                <vs-checkbox v-model="data[indextr].isAutoDenied" class="pointer-events-none" />
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr> 
                    </template>
                </vs-table>
            </template>
             
        </div>

        <!-- ADD APPROVERS -->
            <vs-prompt
                class="email-compose"
                title="Approvers"
                accept-text= "Submit"
                @accept="onAddApprovers"
                :is-valid="validForm"
                :active.sync="activePromptNewApprovers">
                <vx-card title="Fill-out the following information">

                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Approvers</span><span style="color:red">*</span>
                            <v-select name="approvers-name" v-model="approvers" label="fullName" :options="getApprovers" placeholder="Please Select"/>

                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span  class="text-sm">Module</span><span style="color:red">*</span>
                            <v-select name="module-name" v-model="modules" label="moduleName" :options="getModules" placeholder="Please Select"/>

                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span  class="text-sm">Priority</span><span style="color:red">*</span>
                            <v-select name="priority-name" v-model="priority" label="priorityName" :options="getPriority" placeholder="Please Select"/>

                        </div>
                    
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span  class="text-sm">From</span>
                        <datepicker name="fromDate-name" class="w-full" v-model="fromDate" placeholder="Select Date"/>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span  class="text-sm">To</span>
                            <datepicker name="toDate-name" class="w-full" v-model="toDate" placeholder="Select Date" />
                            
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        
                        <div class="vx-col sm:w-1/3 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isNoEndDate" >No EndDate?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/3 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isActive">Active?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        
                        <div class="vx-col sm:w-1/3 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isAutoApproved" >Auto Approved?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/3 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isAutoDenied">Auto Denied?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                
                </vx-card>
            </vs-prompt>
           <!-- EDIT APPROVERS -->
            <vs-prompt
                class="email-compose"
                title="Approvers"
                accept-text= "Submit"
                @accept="onEditApprovers"
                :is-valid="validForm"
                :active.sync="activePromptEditApprovers">
                <vx-card title="Edit the following information">

                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Approvers</span><span style="color:red">*</span>
                            <v-select name="approvers-name" v-model="approvers" label="fullName" :options="getApprovers" placeholder="Please Select"/>

                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span  class="text-sm">Module</span><span style="color:red">*</span>
                            <v-select name="module-name" v-model="modules" label="moduleName" :options="getModules" placeholder="Please Select"/>

                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span  class="text-sm">Priority</span><span style="color:red">*</span>
                            <v-select name="priority-name" v-model="priority" label="priorityName" :options="getPriority" placeholder="Please Select"/>

                        </div>
                    
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span  class="text-sm">From</span>
                        <datepicker name="fromDate-name" class="w-full" v-model="fromDate" placeholder="Select Date"/>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <span  class="text-sm">To</span>
                            <datepicker name="toDate-name" class="w-full" v-model="toDate" placeholder="Select Date" />
                            
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        
                        <div class="vx-col sm:w-1/3 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isNoEndDate" >No EndDate?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/3 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isActive">Active?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        
                        <div class="vx-col sm:w-1/3 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isAutoApproved" >Auto Approved?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/3 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="isAutoDenied">Auto Denied?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            employeeApprovers   : null,
            id                  : 0,
            approvers           : [],
            modules             : [],
            priority            : [1],
            fromDate            : null,
            toDate              : null,
            isNoEndDate         : true,
            isActive            : true,
            isAutoApproved      : false,
            isAutoDenied        : false,
            userId              : null,

            uid                 : null,
            activePromptNewApprovers    : false,
            activePromptEditApprovers    : false,

            format: "d MMMM yyyy",

        }
    },
    created() {
            this.$vs.loading()
            
            this.uid = this.$route.params.id
            this.$store.dispatch('hrms/getAllApproversByUserId',  this.uid )
                    .then((res) => {
                        this.$vs.loading.close()
                        // this.employeeApprovers = res.data.data
                    })
                    .catch(() => {
                        this.$vs.loading.close()
                    })

            
    },
    computed: {
        getuserApprovers() {
            return this.$store.state.hrms.employeeApprovers
        },
        getApprovers() {
            return this.$store.state.hrms.allEmployee 
            // set(value) { this.$store.dispatch('hrms/getAllEmployee') }
        },
        getModules() {
            return this.$store.state.lookup.moduleLookup
        },
        getPriority() {
            return this.$store.state.lookup.priorityLookup
        },
        getEmployeeByUserId() {
            return (id) =>  this.$store.getters['hrms/getEmployeeByUserId'](id)
        }, 
        moduleLookup() {
            return (id) =>  this.$store.getters['lookup/moduleLookup'](id)
        },
        priorityLookup() {
            return (id) =>  this.$store.getters['lookup/priorityLookup'](id)
        },
        validForm(){
            
        },
        
    },
    watch : {
        isAutoApproved () {
            this.isAutoDenied = !this.isAutoApproved
        },
        isAutoDenied () {
            this.isAutoApproved = !this.isAutoDenied
        }
    },
    methods: {
        promptAddNewApprovers() {
            this.activePromptNewApprovers = true
        },
        onAddApprovers() {
            this.$validator.validateAll().then(result => {
            if (result) {
                    // this.$vs.loading()

                    const data = {
                        approverId: this.approvers.id,
                        module: this.modules.value,
                        priority: this.priority.value,
                        fromDate: this.fromDate,
                        toDate: this.toDate,
                        isNoEndDate: this.isNoEndDate,
                        isActive: this.isActive,
                        isAutoApproved: this.isAutoApproved,
                        isAutoDenied: this.isAutoDenied,
                        userId: this.uid,
                        currentUserId: this.$store.state.AppActiveUser.uid
                    }

                    this.$store.dispatch('hrms/AddApprovers', data)
                    .then((response) =>{
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Aprovers Saved',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                 } else {
                    // form have errors
                    this.$vs.notify({
                                title: 'Error',
                                text: error.message,
                                iconPack: 'feather',
                                icon: 'icon-x-octagon',
                                color: 'danger'
                            })
                }
                })
        },
        onEditApprovers() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                      : this.id,
                    approverId              : this.approvers.id,
                    module                  : this.modules.value,
                    priority                : this.priority.value,
                    fromDate                : this.fromDate,
                    toDate                  : this.toDate,
                    isNoEndDate             : this.isNoEndDate,
                    isActive                : this.isActive,
                    isAutoApproved          : this.isAutoApproved,
                    isAutoDenied            : this.isAutoDenied,
                    userId                  : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateApprovers', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Approvers Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                 } else {
                    // form have errors
                    this.$vs.notify({
                                title: 'Error',
                                text: error.message,
                                iconPack: 'feather',
                                icon: 'icon-x-octagon',
                                color: 'danger'
                            })
                }
                })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeApprovers'](Id)
            this.id = e.id,
            this.approvers = this.getEmployeeByUserId(e.approverId),
            this.modules = this.moduleLookup(e.module),
            this.priority = this.priorityLookup(e.priority),
            this.fromDate = e.fromDate,
            this.toDate = e.toDate,
            this.isNoEndDate = e.isNoEndDate,
            this.isActive = e.isActive,
            this.isAutoApproved = e.isAutoApproved,
            this.isAutoDenied = e.isAutoDenied,
            this.userId = e.userId

            this.activePromptEditApprovers = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteApprovers', id)
            .then(res => {
                this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Approvers Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>